import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/Box';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const items = [
  {
    title: 'Audiencia de bienestar',
    feedback:
      'Familias, profesionales y adultos mayores que consumen noticias, salud y estilo de vida en TNO Network — el público natural de una óptica de confianza.',
  },
  {
    title: 'Noticiero + SEO + señal',
    feedback:
      'No elegís un solo canal: Noticias TNO da credibilidad, la rotativa da frecuencia, el Digest da permanencia en Google y los inserts llevan la marca a redes.',
  },
  {
    title: 'Planes que crecen contigo',
    feedback:
      'Empezá en Bronce y escalá a Oro cuando quieras más rotativas, más Digest y más inserts — sin renegociar la estructura de la alianza.',
  },
];

const PorQueTNO = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography variant="h4" fontWeight={700} align="left" gutterBottom>
          ¿Por qué TNO Network
          <br />
          para Óptica Berlud?
        </Typography>
      </Box>
      <Grid container spacing={3}>
        {items.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              width="100%"
              height="100%"
              data-aos="fade-up"
              component={Card}
              display="flex"
              flexDirection="column"
              sx={{ borderTop: 4, borderColor: theme.palette.primary.main }}
            >
              <CardContent sx={{ flex: 1 }}>
                <Typography variant="h6" fontWeight={700} gutterBottom color="primary">
                  {item.title}
                </Typography>
                <Typography color="textSecondary">{item.feedback}</Typography>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PorQueTNO;
